import Vue from "vue";
import {
  ToastPlugin,
  ModalPlugin,
  BootstrapVue,
  BootstrapVueIcons,
} from "bootstrap-vue";

import { ValidationProvider, ValidationObserver } from "vee-validate";

import "@progress/kendo-ui";
import "@progress/kendo-theme-default/dist/all.css";
import { DateinputsInstaller } from "@progress/kendo-dateinputs-vue-wrapper";

import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import MessageAlertPlugin from "@/plugins/MessageAlertPlugin";
import VCalendar from 'v-calendar';

import flatpickr from "flatpickr"
const Spanish = require("flatpickr/dist/l10n/es.js").default.es;
flatpickr.localize(Spanish); // default locale is now Russian

import { fetchNewRoutes } from "@/db/sections.js"

import VueCompositionAPI from "@vue/composition-api";

import ScrollBar from "@morioh/v-perfect-scrollbar";
import money from "v-money";
import VueTheMask from "vue-the-mask";
import i18n from "@/libs/i18n";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import { initialize } from "./service/general";

import generalMixins from "./mixins/general";
import modalMixin from "@/mixins/modal";
import loadingMixin from "@/mixins/loading";
import PlanillaCajaFilters from "@/filters/PlanillaCajaFilters.js";
import cuentaBancariaFilters from "@/filters/cuentaBancariaFilters.js";

import "./global-components";
import "./filters/general";
import "./filters/dates";
import "./ws/websocket.config";

import "@axios";
import "@/libs/acl";
import "@/libs/portal-vue";
import "@/libs/clipboard";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
import "@/libs/vue-select";
import "@/libs/tour";

import "./filters/money";
import "./validation/rules";
import "@/@fake-db/db";

import ReadMore from 'vue-read-more';


Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
Vue.use(ScrollBar);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(DateinputsInstaller);
Vue.use(VueFlatPickr);
Vue.use(VueCompositionAPI);
Vue.use(VueTheMask);
Vue.use(VueCompositionAPI)
Vue.use(money, { precision: 4 });
Vue.use(VueTheMask)
Vue.use(ReadMore);
Vue.use(MessageAlertPlugin)
Vue.mixin(modalMixin);
Vue.mixin(loadingMixin);
Vue.mixin(generalMixins);

Vue.use(VCalendar, {
  componentPrefix: 'vc'
})

Vue.use(PlanillaCajaFilters);
Vue.use(cuentaBancariaFilters);

Vue.directive('uppercase', {
  update: function (el) {
    el.value = el.value.toUpperCase();
  }
});

require("@core/assets/fonts/feather/iconfont.css");
require("@core/assets/general-fonts/fonts.css");
require("@core/scss/core.scss");
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;
initialize(router)

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

window.app = app;

fetchNewRoutes();